import React from "react";

export default function PanelHeader({ title }) {
  return (
    <div className="panel-heading text-center">
      <strong>{title}</strong>
    </div>
  );
}
